import styles from "./InfoBox.module.scss";

export default function InfoBox({ label, classNames, children }) {
  return (
    <div className={`${styles.infoBox} ${classNames}`}>
      <span className={styles.infoBoxLabel}>{label}</span>
      {children && (
        <span className={`${styles.infoBoxContent}`}>{children}</span>
      )}
    </div>
  );
}
